import { getApiUrl } from '../../util/api/api'

const fetchRecruiterInfo = async () => {
  const response = await fetch(getApiUrl('/dashboard/api/recruiter'))
  
  if (response?.ok) {
    const responseJson = await response.json()
    return Promise.resolve({ status: response.status, data: responseJson})
  } else {
    return Promise.reject(response ? { status: response.status, data: response.statusText } : null)
  }
}

export default fetchRecruiterInfo
